import { createAction, handleActions } from 'redux-actions';
import { NAVBAR_CONFIG_SET } from './constants';

export const setNavbarConfig = createAction(NAVBAR_CONFIG_SET);

export default handleActions({
  [NAVBAR_CONFIG_SET]: (state, action) => action.payload,
}, {});
